"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Organisms = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const node_1 = require("../common/node");
const myMap_1 = require("../util/myMap");
const dataTables_1 = require("./dataTables");
const hero_1 = require("./hero");
const primaryNav_1 = require("./primaryNav");
const secondaryNav_1 = require("./secondaryNav");
const footerAndCopyright_1 = require("./footerAndCopyright");
/**
 * All organisms.
 * @category Organisms
 */
class Organisms extends node_1.Node {
    constructor(designSystem) {
        super("organisms", designSystem);
        this.organisms = new myMap_1.MyMap();
        this.designSystem = designSystem;
        this.dataTables = new dataTables_1.DataTables(this);
        this.hero = new hero_1.Hero(this);
        this.primaryNav = new primaryNav_1.PrimaryNav(this);
        this.secondaryNav = new secondaryNav_1.SecondaryNav(this);
        this.footerAndCopyright = new footerAndCopyright_1.FooterAndCopyright(this);
        this.addDependency(designSystem.atoms);
    }
    getOrganism(key) {
        const organism = this.organisms.get(key);
        if (!organism) {
            throw new Error(`Organism '${key}' was not found`);
        }
        return organism;
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.dataTables.deserialize(obj.dataTables);
        this.hero.deserialize(obj.hero);
        this.primaryNav.deserialize(obj.primaryNav);
        this.secondaryNav.deserialize(obj.secondaryNav);
        this.footerAndCopyright.deserialize(obj.footerAndCopyright);
    }
    serialize() {
        const obj = {};
        obj.dataTables = this.dataTables.serialize();
        obj.hero = this.hero.serialize();
        obj.primaryNav = this.primaryNav.serialize();
        obj.secondaryNav = this.secondaryNav.serialize();
        obj.footerAndCopyright = this.footerAndCopyright.serialize();
        return obj;
    }
}
exports.Organisms = Organisms;
